import { useQuery } from "@tanstack/react-query";

import { getCountryByCode } from "helpers/countries";
import RegionService from "services/Regions";

const getParsedCountries = ({ regions = [], regionId }) => {
  if (!regionId) {
    return [];
  }

  const selectedRegion = regions.find(region => region.id === regionId);

  if (!selectedRegion) {
    return [];
  }

  return selectedRegion.countries.map(code => ({
    key: code,
    value: code,
    text: getCountryByCode(code).text,
  }));
};

export function useRegionCountry({ regionId }) {
  const { data: regionsData, isFetched } = useQuery({
    queryKey: ["regions-dropdown"],
    queryFn: RegionService.getRegions,
    initialData: [],
  });

  const parsedRegions = regionsData.map(region => ({
    key: region.id,
    value: region.id,
    text: region.name,
  }));

  const parsedCountries = getParsedCountries({
    regions: regionsData,
    regionId,
  });

  return {
    regionRecords: regionsData,
    regions: parsedRegions,
    countries: parsedCountries,
    isFetched,
  };
}
